import "../scss/page.scss";

import "../scss/personal-data.scss";

import "jquery-match-height";

import "./scripts/ebook.js";

import "./scripts/personal-data/form.js";